import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	platformApi,
	PlatformsModel,
	platformNS,
	platformSlice,
	platformSelector,
} from 'Pages/advertisement'

function* getPlatformsList(action: platformNS.getPlatformsList) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(platformSlice.actions.clearAllPlatform())
		}
		const res = yield* call(platformApi.getPlatformList, (requestParams || params).withTotalPages)
		const accesses = new ResponseCatalog<PlatformsModel>(res)
		if (!clear) {
			const oldEntries = yield* select(platformSelector.selectPlatformEntries)
			accesses.entries = oldEntries.concat(res.entries)
		}
		yield* put(platformSlice.actions.setRequestParams(requestParams))
		yield* put(platformSlice.actions.setPlatformsList(accesses))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* platformSaga() {
	yield* takeLatest(platformSlice.actions.getPlatformsList.type, getPlatformsList)
}
